<style lang="less" scoped>
.kyteam{position: relative;width: 100%;display: flex;margin-bottom: 20px;}
.content{display: flex;flex-direction: column; justify-content: center;width: 1160px; margin: auto;}
.imgbox{display: flex;margin-bottom: 40px;}
p{font-family: MicrosoftYaHei; font-size: 20px;text-align: left;margin: 10px auto;text-indent: 2em;line-height: 40px;}
ul{list-style: none;}
li{display: flex;margin: 20px auto;}
.photo{width:260px;height: 260px;margin: 50px 80px;}
li:nth-child(odd){flex-direction: row;}
li:nth-child(even){flex-direction: row-reverse;}
.main{width: 600px;}
.name, .description{font-weight: 600;}
</style>

<template>
  <div class="kyteam">
    <div class="content">
      <a href="http://www.yingkelawyer.com" target="_blank"><img src="static/images/官网首页/东盟法律咨询/盈科横幅.jpg" style="width: 400px;cursor: pointer;float: left;margin: 10px 0px;"></a>
      <a href="http://www.yingkelawyer.com" target="_blank"><img src="static/images/官网首页/东盟法律咨询/盈科.jpg" style="width: 1160px;cursor: pointer;"></a>
      <img src="static/images/官网首页/东盟法律咨询/law_CP.png" style="width: 400px;margin: 50px auto;">
      <p>北京市盈科（南宁）律师事务所是2015年9月1日设立的区直属律师事务所。选址于青秀万达广场甲2栋34层，视野开阔、环境优雅、交通便捷。律所办公面积达2000余平方米，所内设有律师办公室、洽谈室、中式会客室、西式会客室、咖啡厅、多媒体大型会议室、模拟法庭、员工活动室等公共设施，更有全新一代高效会议设备—智能会议平板，力求为律师和客户提供商务舒适的办公环境与高效的会议方式。截止2021年8月，盈科南宁已有员工160余人，其中汇聚各个专业领域律师105名，多数毕业于国内外知名院校，多人具有硕士以上学历，具有丰富的法律实务办案经验。</p>
      <p>近年来，广西经济和社会发展取得长足的进步，尤其是作为东盟开放的前沿。盈科南宁坚持“党建引领，建设全球领先律师事务所”，秉承“全球视野、本土智慧”，坚持“规模化、专业化、品牌化、国际化”发展方针，恪守“诚信、卓越、创新、开放、共享”的盈科理念，积极吸纳优秀的法律人才，为广西的法治建设，尤其是面向东盟的商务活动提供优质的全球“一站式”法律服务，为广西经济和社会发展做出积极的贡献。</p>
      <img src="static/images/官网首页/东盟法律咨询/law_ITLT.png" style="width: 600px;margin: 50px auto;">
      <div class="imgbox">
        <img src="static/images/官网首页/东盟法律咨询/团队.jpg" style="width: 420px;height: 380px; margin: 0px 20px 0px 10px;vertical-align: middle;">
        <p>韦霄云律师团队由东盟各国律师联合组建，法律服务体系已覆盖东盟10国。秉承“全球视野、本土智慧”，坚持“规模化、专业化、品牌化、国际化”发展方针，恪守“诚信、卓越、创新、开放、共享”的理念，面向东盟的商务活动提供优质的全球“一站式”法律服务。执业领域主要涉及能源、矿业与基础建设、企业并购、银行与金融、公司法、劳动法、房地产以及税法。</p>
      </div>

      <ul >
        <li v-for="(item,index) in lawyerList" :key="index">
          <img class="photo" :src="item.pic" />
          <div class="main">
            <img src="static/images/官网首页/东盟法律咨询/ic_shape.png" style="margin-left: -450px;" />
            <p class="name">{{ item.name }}</p>
            <p class="description">{{ item.description }}</p>
            <p class="introduce" style="text-indent: 2em;">{{ item.introduce }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data()
  {
    return {
      lawyerList: [
        {
          name: '韦霄云',
          pic: 'static/images/官网首页/东盟法律咨询/image_韦霄云.png',
          description: '北京市盈科律师事务所（南宁）高级合伙人，管委会主任，法学教授',
          introduce: '广西壮族自治区政府法律顾问人才库成员，南宁市政府立法咨询员，擅长民商事诉讼以及职务犯罪辩护。'
        },
        {
          name: '刘雪莲',
          pic: 'static/images/官网首页/东盟法律咨询/image_刘雪莲.png',
          description: '北京盈科律师事务所（乌鲁木齐）股权高级合伙人、北京盈科对外投资与贸易专业委员会副主任、涉外工程法律事务部主任',
          introduce: '从事法律职业30年。曾在国企担任专职法务工作四年，在中级法院从事民商事审判工作十年，担任过中级法院民一庭庭长，审判委员会委员。在大学从事专职法学教研工作五年，高校法学副教授，硕士生导师。专注于中国企业“走出去”涉及的法律服务。涉外法律服务涉及境外投资、收购并购及建设项目提供全过程法律服务。'
        },
        {
          name: '曾勤博 BOB TSENG',
          pic: 'static/images/官网首页/东盟法律咨询/image_曾勤博.png',
          description: '律师管理合伙人',
          introduce: '缅甸律师协会国际关系及教育委员会委员、PARAMI 大学校董、海南国际仲裁院仲裁员、缅甸国际仲裁中心仲裁员。'
        },
        {
          name: '黄建堂 SCOTT JT HUANG',
          pic: 'static/images/官网首页/东盟法律咨询/image_黄建堂.png',
          description: '',
          introduce: '曾在国有政策性保险公司（中国出口信用保险公司-SINOSURE）及中国电子 集团（CEC）旗下出口供应链企业任职，拥有十余年信用风险管理、国际贸易投融资、出口信用保险、供应链管理及国内外法律等领域的实操经验。作为“一带一路”律师联盟（BRILA：THE BELTAND ROAD INTERNATIONAL LAWYERS ASSOCIATION）首批会员，现在执业方向专注于涉外法律事务、民商事法 律事务、供应链金融及争议解决等领域。'
        },
        {
          name: '林洋宏',
          pic: 'static/images/官网首页/东盟法律咨询/image_林洋宏.png',
          description: '马来西亚律师',
          introduce: '在律师事务多年实践中，积累了丰富的经验，包括合同和商业纠纷、土地相关纠纷、家庭纠纷、仲裁和裁决，公司清盘和程序。在处理有争议和无争议的遗嘱认证事务方面经验也很丰富。'
        },
        {
          name: 'U THAN NAING',
          pic: 'static/images/官网首页/东盟法律咨询/image_UThanNaing.png',
          description: '缅甸资深大律师(ADVOCATE)',
          introduce: '  原为缅甸司法部（检察总长办公室）资深官员。担任 27年的执法官员。专精于诉讼实务、公司法、契约法、合同撰写、合资架构等。'
        },
        {
          name: 'INGYIN HMWE',
          pic: 'static/images/官网首页/东盟法律咨询/image_IngyinHmwe.png',
          description: '缅甸律师',
          introduce: '    在公司法、土地法、及投资法规有丰富的经验，参与过许多企业并购、土地尽调、及投资架构的谘询及落实。INGYIN 熟悉银行金融、不动产开发、及基础建设等项目在缅甸的落地及营运实践。'
        },
        {
          name: '曾品方 STANLEY TSENG',
          pic: 'static/images/官网首页/东盟法律咨询/image_曾品方.png',
          description: '资深顾问',
          introduce: '  在投资法、公司法、合同起草和谈判方面有着丰富的经验，曾任和硕公司高级法律顾问及驻华代表，除了为世界 500 强企业提供咨询，曾律师还为一些 IT 巨头提供服务，如苹果、微软和华为。'
        },
        {
          name: 'MANILYN ROSE S.SoTELO',
          pic: 'static/images/官网首页/东盟法律咨询/image_Manilyn.png',
          description: '菲律宾律师',
          introduce: '具有较深的民商法以相关法律理论和实践知识。有丰富的诉讼和公司事务工作经验。精通企业注册、重组和公司并购。参与缅甸法律业务超过四年，对缅甸的公司法、投资法、土地法规、契约法等有充足的理解。'
        },
        {
          name: '郑顺香 TRACY ZHENG',
          pic: 'static/images/官网首页/东盟法律咨询/image_郑顺香.png',
          description: '中国注册税务师',
          introduce: '曾任职于某知名四大会计师事务所十年税务从业经历，从事税务相关咨询工作，致力于为企业跨境投资提供税务咨询，包括帮助搭建中国及海外业务模式及投资构架，提供税务筹划以降低企业整体税负水平等。'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/YKteam.vue